module.exports = __webpack_public_path__ + "static/media/vtex26.a74460d7.png";